import CollapsibleSection from '@/global/components/CollapsibleSection'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import Grid from '@/global/components/ui/Grid'
import { TRelatorioAusencias } from '@acme/core'
import { usePeriodo } from 'global/components/Selects/SelectPeriodo'
import ContentGuide from 'global/guides/ContentGuide'
import { ajustes } from 'service/api'
import { useStore } from 'store'
import { BotaoEditar, BotaoExcluir } from './Opcoes'

interface IProps {
    rows?: TRelatorioAusencias[]
}

export default function LancamentosAnteriores({ rows = [] }: IProps) {
    if (!rows.length) return null

    return (
        <CollapsibleSection title="Lançamentos anteriores" scrollToView>
            <Grid container>
                <Grid
                    item
                    xs={12}
                    className="min-h-52 max-h-52 overflow-hidden"
                >
                    <ContentGuide.DataGrid
                        loading={false}
                        columns={[
                            {
                                field: 'ocorrencia',
                                headerName: 'Ocorrência',
                                minWidth: 100,
                                disableColumnMenu: true,
                                flex: 1,
                            },
                            {
                                field: 'periodo',
                                headerName: 'Período',
                                width: 120,
                                disableColumnMenu: true,
                                valueGetter: ({ row }) =>
                                    row.dataFim
                                        ? `${row.dataInicio} - ${row.dataFim}`
                                        : row.dataInicio,
                            },
                            {
                                ...optionsColumn,
                                field: '__editar',
                                renderCell: BotaoEditar,
                            },
                            {
                                ...optionsColumn,
                                field: '__excluir',
                                renderCell: BotaoExcluir,
                            },
                        ]}
                        rows={rows}
                        ToolbarProps={{ hideToolbar: true }}
                        headerHeight={45}
                        rowHeight={45}
                        hideFooter
                    />
                </Grid>
            </Grid>
        </CollapsibleSection>
    )
}

interface IAsyncProps {
    tipoAusencia: TRelatorioAusencias['tipoAusencia']
}

export function LancamentosAnterioresAsync({ tipoAusencia }: IAsyncProps) {
    const empresaId = useStore(state => state.companyId)
    const funcionarioId = useStore(state => state.employeeId)

    const [[dataInicial, dataFinal]] = usePeriodo()
    const { data } = ajustes.relatorioAusencias.useFetch({
        queryParams: {
            dataInicial,
            dataFinal,
            empresaId,
        },
        enabled: empresaId > 0 && funcionarioId > 0,
    })
    const rows = data
        ?.filter(row => row.tipoAusencia === tipoAusencia)
        ?.filter(item => item.funcionarioId == funcionarioId)

    return <LancamentosAnteriores rows={rows} />
}
